export default "__VITE_ASSET__Dx28xME1__"